import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.object.to-string.js";
/**
 * @description to capitalize value passed as parameter
 *
 * @param value value to capitalize
 * @param every boolean to set capital letter to every word
 */

var capitalize = function capitalize(_ref) {
  var value = _ref.value,
    _ref$every = _ref.every,
    every = _ref$every === void 0 ? false : _ref$every;
  if (!value || typeof value !== 'string') return '';
  var valueStr = value.toString().toLowerCase();
  if (every) return valueStr.replace(/\b\w/g, function (letter) {
    return letter.toUpperCase();
  });
  return valueStr.charAt(0).toUpperCase() + valueStr.slice(1);
};
export default capitalize;